import {
    FormGroup,
    FormControl,
    FormGroupDirective,
    NgForm,
    ValidatorFn,
    ValidationErrors,
    AbstractControl
} from '@angular/forms';
import {ErrorStateMatcher} from '@angular/material/core';
import * as moment from 'moment';
import {FileUploader} from 'ng2-file-upload';


/**
 * Пользовательские функции валидатора для проверки реактивной формы
 */
export class CustomValidators {
    /**
     * Проверяет, что дочерние элементы управления в группе форм равны
     */
    static childrenEqual: ValidatorFn = (formGroup: FormGroup) => {
        const [firstControlName, ...otherControlNames] = Object.keys(formGroup.controls || {});
        const isValid = otherControlNames.every(controlName => (formGroup.get(controlName).value === formGroup.get(firstControlName).value || formGroup.get(controlName).value === null));
        return isValid ? null : {childrenNotEqual: true};
    };

    /**
     * Валидация даты
     */
    static date: ValidatorFn = (formGroup: FormGroup) => {
        if (!formGroup.value) {
            return null;
        }
        const date = moment(formGroup.value);
        return date.isValid() ? null : {date: true};
    };

    /**
     * Валидация авто дополняемого поля
     */
    static autocomplete: ValidatorFn = (formGroup: FormGroup) => {
        return !formGroup.value || !(formGroup.value && formGroup.value.id) ? {autocomplete: true} : null;
    };

    /**
     * Валидация чекбоксов на пустоту
     */
    static checkbox: ValidatorFn = (formGroup: FormGroup) => {
        return formGroup.value ? null : {checkbox: true};
    };

    /**
     * Валидация телефона
     */
    static phone: ValidatorFn = (formGroup: FormGroup) => {
        return !formGroup.value || (formGroup.value && typeof formGroup.value == 'string'
            && formGroup.value.match(regExps.phone)) ? null : {phone: true};
    };

    /**
     * Валидация пустоты файла
     */
    static fileRequired(file: FileUploader): ValidatorFn {
        return (): { fileRequired: boolean } | null => {
            return file.queue.length > 0 ? null : {fileRequired: true};
        };
    };

    /**
     * Валидатор регулярного выражения
     * @param regex регулярное выражение
     * @param error ошибка
     */
    static patternValidator(regex: RegExp, error: ValidationErrors): ValidatorFn {
        return (control: AbstractControl): { [key: string]: any } => {
            if (!control.value) {
                return null;
            }
            const valid = regex.test(control.value);
            return valid ? null : error;
        };
    }

    /**
     *
     * @param field
     * @param data данные для подсчета в таблице строк
     * array( '1397' => {
     *                    relation_fields => [{}]
     *                    total => 6
     *                    rows => [{}]
     *                                  })
     */
    static relationTableValidator(field, data): ValidatorFn {
        return (control: AbstractControl): { [key: string]: any } => {
            return Number(data[field].total) > 0 ? null : {relationTableValidator: true};
        };
    }


    /**
     * Валидатор на целое число
     * @param formControl AbstractControl
     */
    static integerValidator: ValidatorFn = (formControl: AbstractControl) => {
        if (!formControl.value) {
            return null;
        }

        return Number.isInteger(Number(formControl.value)) ? null : {integer: true};
    }
 }

/**
 * Пользовательский ErrorStateMatcher, который возвращает true (существует ошибка), когда группа родительских форм
 * недействительна, и элемент управления был затронут
 */
export class ConfirmValidParentMatcher implements ErrorStateMatcher {
    isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
        return control.parent.invalid && control.touched;
    }
}

/**
 * Коллекция многоразовых RegExps
 */
export const regExps: { [key: string]: RegExp } = {
    password: /^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{7,15}$/,
    phone: /(\+[0-9]{11})|([0-9]{11})|([0-9]\([0-9][0-9][0-9]\)[0-9][0-9][0-9]-[0-9][0-9]-[0-9][0-9])|(\+[0-9]\([0-9][0-9][0-9]\)[0-9][0-9][0-9]-[0-9][0-9]-[0-9][0-9])/,
};
